import { laborHoursConstant } from 'src/redux/actions/constant';

const intitialstate: any = {
  response: null,
  // The `content` rows lifted out of the paged envelope — what the date dropdown lists.
  cycles: [],
  isSuccess: false,
  loading: false,
};

export const getPayPeriodCyclesReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case laborHoursConstant.GET_PAY_PERIOD_CYCLES_SUCCESS: {
      const data = action.payload?.data;
      return {
        ...state,
        response: data,
        cycles: Array.isArray(data) ? data : Array.isArray(data?.content) ? data.content : [],
        isSuccess: true,
        loading: false,
      };
    }

    case laborHoursConstant.GET_PAY_PERIOD_CYCLES_FAILURE:
      return { ...state, response: action.payload, cycles: [], isSuccess: false, loading: false };

    case laborHoursConstant.GET_PAY_PERIOD_CYCLES_LOADER:
      return { ...state, loading: true };

    case laborHoursConstant.GET_PAY_PERIOD_CYCLES_RESET:
      return intitialstate;

    default:
      return state;
  }
};
